import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Container, Row, Col } from 'reactstrap';

import { movies } from '../../constants/movies';
import * as vars  from '../../constants/constants';
import { Videos360 } from '../../constants/videos';

import { showSearchBar } from '../../actions/HeaderActions';
import { searchText } from '../../actions/SearchActions';
import { getVideoOrChannelRelatedData } from '../../actions/PlayActions';
import { console_log } from '../../utils/helper';
import Swiper from 'react-id-swiper';
import {config} from './../../constants/domainConfig'
import { FormattedMessage } from 'react-intl';
import {getUid} from './../../utils/helper'
class SearchPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            type: ''
        };

        this.goToPlay = this.goToPlay.bind(this);
        this.goToPlayOthers = this.goToPlayOthers.bind(this);
    }

    componentWillMount() {
        console_log(this.props.path.split("/"));
        let pathName = this.props.path.split("/");

        switch (pathName[1]) {
            case "category": {
                if (pathName[2] == "tv") {
                    this.setState({
                        type: "channels"
                    });
                }
                if (pathName[2] == "vod") {
                    this.setState({
                        type: "videos"
                    });
                }
                break;
            }
            case "play": {
                if (pathName[2] == "channel") {
                    this.setState({
                        type: "channels"
                    });
                }
                if (pathName[2] == "video") {
                    this.setState({
                        type: "videos"
                    });
                }
                break;
            }
            case "channels": {
                this.setState({
                    type: "channels"
                });
                break;
            }
            case "show":
            case "videos":
            case "movies": {
                this.setState({
                    type: "videos"
                });
                break;
            }
            default: {
                this.setState({
                    type: ''
                });
            }
        }
    }

    componentWillUnmount() {
        this.props.searchText('');
    }

    goToPlay(data, event) {
        event.preventDefault();
        this.props.showSearchBar(!this.props.header.showSearchBar);
        this.props.getVideoOrChannelRelatedData(data);
        this.props.searchText('');
        if (data.channel) {
            this.props.goToPage('/play/channel');
        } else {
            this.props.goToPage(`/play/video/?vid=${data.video.id}&uid=${getUid()}`);
        }
    }

    goToPlayOthers(data, event) {
        event.preventDefault();
        this.props.showSearchBar(!this.props.header.showSearchBar);
        this.props.getVideoOrChannelRelatedData(data);
        this.props.searchText('');
        this.props.goToPage('/show');
    }

	render() {
        var regEx = new RegExp(this.props.search.searchText, 'i');

        let videoSearch = [].concat.apply([], this.props.category.videos.map((c) => c.videos)).filter((v) => {
            if (regEx.test(v.name[config.lang])) {
                return v;
            }
        });

        const slides = {
            spaceBetween: 30,
            direction: 'horizontal',
            slidesPerView: 'auto',
            speed: 500,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpoints: {
                575: {
                    spaceBetween: 15,
                },
            }
        };
	    return (
			<section className="search-page">
                {((this.state.type == '' || this.state.type == "videos")  && (videoSearch.length > 0))?
                    <div className="search-page-container">
                        {Videos360.map((category) => {
                            let newVideos = category.videos.filter((video) => {
                                if (regEx.test(video.name[config.lang])) {
                                    return video;
                                }
                            });
                            if (newVideos.length > 0) {
                                return (
                                    <div className="search-page--es">
                                        <div key={category.id}>
                                            <div className="d-flex justify-content-between channel-head">
                                                <h3 className="channel-title">{category.name}</h3>
                                            </div>
                                            {newVideos.length > 0 ?
                                                <div className="category-slider">
                                                    <Swiper {...slides} rebuildOnUpdate={false} shouldSwiperUpdate={true}>
                                                        {newVideos.reverse().map((video) => {
                                                            return (
                                                                <div key={video.id} className="channels-thumb"
                                                                        onClick={this.goToPlay.bind(this, {video: video})}>
                                                                    <div className="channels-image">
                                                                        <img className="channels-thumb__image"
                                                                                src={video.preview} alt={video.name[config.lang]}/>
                                                                        <div className="channels-thumb__details">
                                                                            <div className="channels-thumb__inner">
                                                                                <div className="channels-thumb__name">
                                                                                    {video.name[config.lang]}
                                                                                </div>
                                                                                <div className="channels-thumb__extra">
                                                                                    <span className="channels-thumb__time">1h 40m</span>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                    </Swiper>
                                                </div>
                                                : ''
                                            }
                                        </div>
                                    </div>
                                )
                            }
                        })}
                    </div>
                    : ""
                }
                {(videoSearch.length <=0)?
                    <div className="no-favorites__pane no-favorites__pane--history">
                        <h4 className="favorites__pane__title">
                            <FormattedMessage id="noResults"
                                defaultMessage="No Results Found"
                            />
                        </h4>
                    </div>
                    : ""
                }
			</section>
		)
	}
}

const mapStateToProps = (state) => {
    return {
        access: state.WelcomeReducer,
        account: state.AccountReducer,
        category: state.CategoryReducer,
        country: state.CountryReducer,
        domain: state.DomainReducer,
        favorite: state.FavoriteReducer,
        flashmessage: state.FlashMessageReducer,
        header: state.HeaderReducer,
        historyVideos: state.HistoryReducer,
        loader: state.ActivityIndicatorReducer,
        play: state.PlayReducer,
        search: state.SearchReducer,
        smartTV: state.SmartTVReducer,
        splash: state.SplashScreenReducer,
        user: state.AuthenticationReducer
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        searchText,
        getVideoOrChannelRelatedData,
        showSearchBar
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchPage);



// WEBPACK FOOTER //
// ./src/components/SearchPage/SearchPage.js